import angular from 'angular'
import routers from './routers.js'
import creatIncomeTaxCtrl from './creatIncomeTaxCtrl.js'

export default angular
    .module('declaration.incomeTax.creatIncomeTax', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('creatIncomeTaxCtrl', creatIncomeTaxCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/incomeTax/creatIncomeTax/index.js